import { Healthgroup } from '../healthgroup/healthgroup';

export class PrescriptionTemplate {
  constructor(
    public id?: number,
    public name?: string,
    public text?: string,
    public healthgroup?: Healthgroup
  ) {}
}
